import React, { useState } from "react";
import NavLogo from "../assets/InnaxysLogo.svg";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../config/LanguageContext.jsx";
import NavDropdownModal from "../components/nav/navDropdownModal.jsx";
import NavOptions from "../components/nav/NavOptions.jsx";
import NavActions from "../components/nav/NavActions.jsx";

const Nav = () => {
  const { currentLanguage } = useLanguage();
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  const handleNavItemClick = (path) => {
    navigate(path);
  };

  const handleBookDemoClick = () => {
    navigate("/bookdemo");
  };

  return (
    <section className="navbar-wrapper">
      <div className="navbar">
        <figure className="innaxys-logo">
          <a href="/">
            <img src={NavLogo} alt="Nav Logo" />
          </a>
        </figure>
        <NavOptions
          handleNavItemClick={handleNavItemClick}
          currentLanguage={currentLanguage}
        />
        <NavActions
          currentLanguage={currentLanguage}
          showDropdown={showDropdown}
          setShowDropdown={setShowDropdown}
          handleBookDemoClick={handleBookDemoClick}
        />
      </div>

      <div
        className={`overlay ${showDropdown ? "visible" : ""}`}
        onClick={() => setShowDropdown(false)}
      ></div>

      {showDropdown && (
        <NavDropdownModal
          onClose={() => setShowDropdown(false)}
          handleNavItemClick={handleNavItemClick}
          handleBookDemoClick={handleBookDemoClick}
        />
      )}
    </section>
  );
};

export default Nav;
